import { ICompany } from '../typescript/interfaces';

export const partners: ICompany[] = [
  { id: 'microsoft', url: 'https://www.microsoft.com/', imgSrc: '/partners/microsoft.svg', alt: 'Microsoft logo' },
  { id: 'dxc', url: 'https://dxc.com/au/en', imgSrc: '/partners/dxc.png', alt: 'DXC logo' },
  { id: 'aws', url: 'https://aws.amazon.com/partners/', imgSrc: '/partners/aws.jpg', alt: 'AWS partner logo' },
  { id: 'genesys', url: 'https://www.genesys.com/', imgSrc: '/partners/genesys.svg', alt: 'Genesys logo' },
  { id: 'blackbox', url: 'https://www.blackbox.com/en-au/', imgSrc: '/partners/blackbox.png', alt: 'Blackbox logo' },
];
